import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MatchUpStatusEnum } from '../../../_shared/models/csTypes/enums/matchup_status';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../_core/services/theme.service';

@Component({
  selector: 'app-int-status',
  templateUrl: './int-status.component.html',
  styleUrls: ['./int-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class IntStatusComponent {
  @Input({ required: true }) matchStatus: MatchUpStatusEnum;
  @Input({ required: true }) sideNumber: number;
  @Input({ required: true }) winningSide: number;
  @Input({ required: true }) serverSideNumber: number;
  @Input({ required: true }) serverNumber: number;
  @Input({ required: true }) returningSide: string;
  @Input({ required: true }) setWinner: boolean;
  public themeService = inject(ThemeService);

  constructor() {}

  getStatus() {
    if (
      this.matchStatus === MatchUpStatusEnum.RETIRED &&
      this.winningSide !== this.sideNumber
    ) {
      return 'RET';
    } else if (this.matchStatus === MatchUpStatusEnum.INCOMPLETE) {
      return 'INC';
    } else if (this.matchStatus === MatchUpStatusEnum.ABANDONED) {
      return 'ABD';
    } else if (
      this.matchStatus === MatchUpStatusEnum.WALKOVER &&
      this.winningSide !== this.sideNumber
    ) {
      return 'WO';
    }
  }
}
